import { JSConn } from "@/utilities/js-conn";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation.vue";
import {
  ref,
  onMounted,
  defineComponent,
  computed,
} from "@vue/composition-api";
import { filter as Rfilter } from "ramda";
import { Truck } from "@/models/Truck";
import { itemRouteBuilder, NamedRts } from "@/router";

import { genericSort, sortIcon } from "@/components/helpers";
import { trucksController } from "@/controllers/trucks";

export default defineComponent({
  name: "trucks",
  components: {
    LoadingAnimation,
  },

  setup(_props, ctx) {
    let $store = ctx.root.$store;

    let dataLoaded = ref(false);
    let loadingMessage = ref("Loading Trucks...");

    let filter = ref("");

    let sortKey = ref<"name" | "tareWeight">("name");
    let sortAsc = ref(true);

    const apiTrucks = computed(() => {
      return $store.getters.trucks as Truck[];
    });

    const localTrucks = ref<Truck[]>([]);

    // const showRouteBuilder = (id: string) => {
    //   return itemRouteBuilder(NamedRts.truckShow, id);
    // };

    const editRouteBuilder = (id: string) => {
      return itemRouteBuilder(NamedRts.truckEditForm, id);
    };

    const trucks = computed(() => {
      let tmpResults = [...localTrucks.value];

      if (filter.value !== "") {
        let tmpReg = new RegExp(filter.value, "i");
        tmpResults = Rfilter((item: any) => {
          let nameResult = tmpReg.test(item.name);
          let tareWeightResult = tmpReg.test(item.tareWeight);

          return nameResult || tareWeightResult;
        }, tmpResults);
      }

      return tmpResults;
    });

    const localSortIcon = (lSortKey: "name" | "tareWeight") => {
      return sortIcon(sortAsc, sortKey, lSortKey);
    };

    const getTrucksByStatus = (status: string) => {
      dataLoaded.value = false;
      const jsConn = new JSConn();
      jsConn.formParams = {
        statuses: [status],
      };
      trucksController.needTrucks(jsConn).then(() => {
        localTrucks.value = [...apiTrucks.value];
        // flip the sort, otherwise on load it would be off
        sortAsc.value = !sortAsc.value;
        updateSort(sortKey.value);
        dataLoaded.value = true;
        return Promise.resolve();
      });
    };

    const updateSort = (lSortKey: "name" | "tareWeight") => {
      localTrucks.value = genericSort(
        [...localTrucks.value],
        sortAsc,
        sortKey,
        lSortKey,
      );
    };

    onMounted(() => {
      getTrucksByStatus("active");
    });

    return {
      dataLoaded,
      loadingMessage,

      trucks,

      filter,

      getTrucksByStatus,
      updateSort,
      localSortIcon,

      // showRouteBuilder,
      editRouteBuilder,
    };
  },
});
